module.exports = __webpack_public_path__ + "static/patrick-betdavid-140c65e3b1fb6853ef8da03d07c0e50f.jpg";